import { createFileRoute, redirect } from '@tanstack/react-router';

// Playground moved under Project Settings. Keep this path working for old
// bookmarks/links by redirecting to its new home.
export const Route = createFileRoute('/_auth/_side-layout/playground')({
  beforeLoad: () => {
    throw redirect({ to: '/project-settings/playground' });
  },
});
